<template>
    <v-container fluid>
        <v-row>
            <sarala-table
                :model="model"
                :resourceName="$tc('resources.user.name', 1)"
                :createRoute="{ name: 'user.create' }"
                ref="table"
            >
                <template #action="{ item }">
                    <edit-btn
                        :to="{
                            name: 'user.edit',
                            params: { id: item.id },
                        }"
                    />

                    <delete-btn
                        :disabled="item.id == 1"
                        @click="deleteItem(item)"
                    />
                </template>
            </sarala-table>
        </v-row>
        <confirm-delete ref="confirmDelete" />
    </v-container>
</template>

<script>
import User from '@/models/User'
import SaralaTable from '@/shared/components/SaralaTable'
export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new User()
        },
    },

    methods: {
        async deleteItem(item) {
            let confirmed = await this.$refs.confirmDelete.confirm(item.name)
            if (!confirmed) return

            await item.delete()

            this.$refs.table.getItems()

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('resources.feedbacks.success.delete', {
                    resource: this.$tc('resources.user.name', 1),
                }),
            )
        },
    },
}
</script>

<style></style>
